import { Row } from 'components/GridItemList';
import { ClassifierData } from 'types/classifiers';
import { EntityTextDto } from 'types/jobPositions';
import { getClassifierText, t } from 'utils/getTranslations';

/** A name's translations as read rows: one per translated language, its gendered forms under the text. */
export const translationRows = (
    classifiers: Record<string, ClassifierData>,
    entityTexts: EntityTextDto[] | null | undefined
): Row[] => {
    const translated = (entityTexts ?? []).filter((text) => text.value || text.textMale || text.textFemale);
    if (translated.length === 0) {
        return [{ label: t('translations.language'), content: '-' }];
    }
    return translated.map((text) => ({
        label: getClassifierText(classifiers['LANGUAGE'], text.langCode),
        content: (
            <div className="flex flex-col">
                {text.value ? <span>{text.value}</span> : null}
                {text.textMale ? (
                    <span>
                        {t('translations.text-male')}: {text.textMale}
                    </span>
                ) : null}
                {text.textFemale ? (
                    <span>
                        {t('translations.text-female')}: {text.textFemale}
                    </span>
                ) : null}
            </div>
        ),
    }));
};
